// GlitchTip client-side initialization for the Vite + React SPA.
// Import this file early in main.tsx to capture errors from app startup.

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  tracesSampleRate: 1,
  sendDefaultPii: true,
  environment: import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE,
});
